import React, { createContext, useContext, useState } from "react";
import { useAuth } from "@/context/AuthContext";

const AppBuilderCtx = createContext(null);

export function AppBuilderProvider({ children }) {
  const { user } = useAuth();
  const [customize, setCustomize] = useState(false);
  const canCustomize = user?.role === "admin";
  return (
    <AppBuilderCtx.Provider value={{ customize: customize && canCustomize, setCustomize, canCustomize }}>
      {children}
    </AppBuilderCtx.Provider>
  );
}

export const useAppBuilder = () => useContext(AppBuilderCtx);
